import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, Spinner, Center, Text } from '@chakra-ui/react';
import { TenantMonthStakeStatsInterface } from '../../../../shared/type/finance.type';

interface StakesFinanceTableTableProps {
  isLoading: boolean;
  data: TenantMonthStakeStatsInterface[];
  headers?: {
    name: string;
    orders: string;
    absences: string;
    toDistribute: string;
    taken: string;
    notTaken: string;
  };
}

const StakesFinanceTable = ({ isLoading, data, headers }: StakesFinanceTableTableProps) => {
  const columnHeaders = {
    name: headers?.name || 'Nazwa',
    orders: headers?.orders || 'Ilość zamówień',
    absences: headers?.absences || 'Ilość nieobecności',
    toDistribute: headers?.toDistribute || 'Do wydania',
    taken: headers?.taken || 'Odebrane',
    notTaken: headers?.notTaken || 'Nieodebrane bez zgłoszonych nieobecności'
  };

  return (
    <Table className="w-full">
      <Thead className="text-xs bg-white">
        <Tr>
          {Object.values(columnHeaders).map((header, index) => (
            <Th
              key={`header-${index}`}
              className="border border-gray-200 py-3 px-4 text-center"
              fontWeight={400}
              textTransform="capitalize">
              {header}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody className="text-sm font-medium text-grayLight-900">
        {isLoading ? (
          <Tr>
            <Td colSpan={6}>
              <Center py={6}>
                <Spinner size="md" />
              </Center>
            </Td>
          </Tr>
        ) : data.length === 0 ? (
          <Tr>
            <Td colSpan={6}>
              <Center py={6}>
                <Text>Brak danych</Text>
              </Center>
            </Td>
          </Tr>
        ) : (
          data.map((row, index) => (
            <Tr key={`row-${index}`} className="border-t border-x bg-white">
              <Td className="px-4 py-5 text-grayLight-600 font-semibold text-left">
                {row.stakeName}
              </Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.count}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.absenceCount}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.toGiveAway}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.takenCount}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.notTakenCount}</Td>
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
};

export default StakesFinanceTable;
